/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState } from 'react';
import SEO from '../components/SEO';
import { graphql, navigate, useStaticQuery } from 'gatsby';
import { Cookies } from 'react-cookie-consent';
import GetSEOData from '../data/SEO';
import PostcodeSearch from '../components/PostcodeSearch';
const { townNamesMatch } = require('../util/util');
import BadgeHeroSection from '../components/HeroSectionBadge';
import CustomerReview from '../components/CustomerReview';
import AnyQuestions from '../components/AnyQuestions';
import { ProductCookie, InterestCookie } from '../data/Cookies';

const PostcodeChecker = ({ location, data }) => {
  const [selectedAddress, setSelectedAddress] = useState(undefined);
  const [inputDisplayValue, setInputDisplayValue] = useState(
    location?.state?.address?.postcode,
  );
  const [chosenProduct, setChosenProduct] = useState(undefined);

  useEffect(() => {
    // Executed on Mount

    let cookie = Cookies.get(InterestCookie);
    if (cookie) {
      const storedAddress = JSON.parse(atob(cookie));
      if (!storedAddress.orderable) {
        navigate('/get-lit/register-interest');
      } else {
        navigate('/secure-order/contact-form-page/', {
          state: {
            address: storedAddress,
          },
        });
      }
    }

    if (selectedAddress) {
      const slug = getRIPageSlug(selectedAddress);
    }

    cookie = Cookies.get(ProductCookie);
    if (cookie) {
      let storedProduct = cookie;
      setChosenProduct(storedProduct);
    }

    // Executed On Dismount
    return () => {
      // As this sometimes seems to retain the script on the page, we want to ensure it's removed.
    };
  }, [selectedAddress]);

  const getRIPageSlug = (address) => {
    let result = undefined;
    pageData.landingPages.edges.forEach((townNode) => {
      if (
        address &&
        (townNamesMatch(townNode.node.townName, address.postalTown) ||
          townNamesMatch(townNode.node.townName, address.addressLine2) ||
          townNamesMatch(townNode.node.townName, address.addressLine3))
      ) {
        result = townNode.node.slug;
      }
    });
    return result;
  };

  let { title, description } = GetSEOData('get-lit');
  const getLitData = data.allDatoCmsPostcodeHeaderModel.nodes[0];

  return (
    <div className="get-lit-container">
      <SEO
        title={title}
        description={description}
        metaTags={getLitData.seoContent}
      />
      <BadgeHeroSection
        heading={getLitData.heading}
        subHeading={getLitData.subheading}
        mode={getLitData.colour}
        layout={getLitData.layout}
        arrowsRight={data.arrowsRight}
        arrowsLeft={data.arrowsLeft}
        getLit={true}
      />
      <CustomerReview />
      <AnyQuestions />
    </div>
  );
};

export default PostcodeChecker;
export const query = graphql`
  query {
    allDatoCmsPostcodeHeaderModel {
      nodes {
        seoContent {
          description
          title
          twitterCard
          image {
            gatsbyImageData
          }
        }
        heading {
          value
        }
        subheading {
          value
        }
        image {
          gatsbyImageData
        }
        colour
        layout
      }
    }

    arrowsLeft: file(relativePath: { eq: "audience-images/arrowsLeft.png" }) {
      name
      relativePath
      childImageSharp {
        gatsbyImageData(
          quality: 75
          placeholder: BLURRED
          layout: CONSTRAINED
          formats: [AUTO, WEBP, AVIF]
        )
      }
      extension
      publicURL
    }
    arrowsRight: file(relativePath: { eq: "audience-images/arrowsRight.png" }) {
      name
      relativePath
      childImageSharp {
        gatsbyImageData(
          quality: 75
          placeholder: BLURRED
          layout: CONSTRAINED
          formats: [AUTO, WEBP, AVIF]
        )
      }
      extension
      publicURL
    }
  }
`;
